module.exports = ".type{\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    font-size: 1.1rem;\n    color: rgb(80,80,80);\n    margin: 0 auto;\n    width: 90%;\n  }\n  \n.mandatory{\n    color: red;\n}\n  \n.doc_input_container{\n    text-align: center;\n}\n  \n.select_doc{\n    width: 100%;\n    text-align: center;\n    color:#828282 ;\n    padding: 1rem 0.6rem;\n    background: #EEEEEE;\n    border-radius: 4px;\n    font-weight: normal;\n    font-size: 13px;\n    line-height: 15px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/doc-type/doc-type.component.css
// module id = ./src/app/questions-type/doc-type/doc-type.component.css
// module chunks = main